import params from './params'

const searchTypeToRoutes = {
  career: '/search?searchType=career&',
  education: '/search?searchType=education&',
  tuition: '/tuition?',
  scholarships: '/scholarships?',
  mbti: '/?',
  internship: '/jobs?',
  jobs: '/jobs?',
  interest: '/?',
  personality: '/personality-assessment',
  resumesearch: '/search'
}

const buildUrlForSearchType = searchMade => `/app${searchTypeToRoutes[searchMade.searchType]}${params.convertParamsObjectIntoString(searchMade.searchParams)}`

const buildUrlForSavedTuitionSearch = savedTuitionSearch => `/app/tuition?${params.convertParamsObjectIntoString(savedTuitionSearch.searchParams)}`

const buildUrlForSavedResumeSearch = savedResumeSearch => `/app/search?${params.convertParamsObjectIntoString(savedResumeSearch.searchParams)}`

const buildUrlForSavedEducationSearch = savedEducationSearch => `/app/search?${params.convertParamsObjectIntoString(savedEducationSearch.searchParams)}`

export default {
  buildUrlForSavedTuitionSearch,
  buildUrlForSavedResumeSearch,
  buildUrlForSearchType,
  buildUrlForSavedEducationSearch,
}



// WEBPACK FOOTER //
// ./src/utils/routing/searches.js